export const blockIconsTextformattingArticleNew = (
	<span className='material-symbols-outlined'>article</span>
);
